// extracted by mini-css-extract-plugin
module.exports = {"freebet-wrapper":"prematchList__freebet-wrapper___oCYgX"};